<template>
  <div class="mobile-wrapper">
    <div v-if="storeReady">
      <div :style="getCartOpen && 'z-index: 0'">
        <!--Coupons-->
        <shop-header
          @show-reorder="(u) => (isShowReorder = u)"
          @show-search="showSearchBox = true"
          :showPopular="isShowPopular"
          :showSearchBox="showSearchBox"
          :menu="JSON.parse(JSON.stringify(storeMenu))"
          :store-id="storeid"
          :categories="availableCategories"
          @filterText="filterTextchange"
          @handleDisplayBill="openSharedCart"
        />
        <div
          class="content-padding-double"
          :style="{ height: `${getHeight}px` }"
        />
        <div class="container-fluid mobile-menu-content">
          <ProductList
            :menu="JSON.parse(JSON.stringify(storeMenu))"
            @show-search="showSearchBox = false"
            @show-popular="setPopularVisibility"
            :showSearchBox="showSearchBox"
            :filterText="filterText"
            :show-reorder="isShowReorder"
            :storeId="storeid"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <Transition name="slide-fade">
        <progress-indicator />
      </Transition>
    </div>
    <order-type
      :key="orderTypeKey"
      v-if="showOrderTypePopup || getOrderTypeModalDisplay"
    ></order-type>
    <enter-name v-if="showEnterNamePopUp && showSharedCart" />
    <guest-count v-if="showGuestCount" />
    <order-placed v-if="getModalProp" />
    <order-bill
      ref="orderBillBottomSheet"
      :orderData="orderData"
      :errorMessage="error"
      :total="total"
      :gst="gst"
      :surcharge="surcharge"
      :table="table"
    />
  </div>
</template>
<style>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100vw);
  /*opacity: 0;*/
}
</style>
<script>
import ProductList from "./products/ProductListMobile";
import ShopHeader from "./partials/shopheaderMobile";
import { mapMutations, mapActions, mapGetters } from "vuex";

import OrderType from "./OrderType";
import { orderTypeHelper } from "../../api/helpers/orderTypeHelper";
import { CONSTANT_ORDER_TYPE_DINEIN } from "../../constants/strings";
import EnterName from "../user/EnterName.vue";
import OrderPlaced from "../shared/OrderPlaced.vue";
import ProgressIndicator from "../progressindicator";
import GuestCount from "./GuestCount.vue";
import OrderBill from "./OrderBill.vue";
import {
  getDeviceUDID,
  getOrder,
  getOrderSummary,
  listenOrder,
  readProductData,
  writeMessageQueue,
} from "../../api/helpers/rtdbHelper";
import { logger } from "../../api/Logger";
import { createOrderForPOS } from "../../api/messageQueueHelper";
import uuid from "uuid/v1";
import { isiOS, sleep } from '../../api/helpers/commonHelpers';

export default {
  components: {
    ProductList,
    ShopHeader,
    OrderType,
    EnterName,
    OrderPlaced,
    ProgressIndicator,
    GuestCount,
    OrderBill,
  },
  props: {
    storeid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showSearchBox: false,
      isShowPopular: true,
      isShowReorder: true,
      filterText: "",
      showOrderTypeSelection: true,
      multipleMenus: true,

      showOrderTypeModalProps: false,
      addToCartOpen: false,
      orderTypeKey: "ordertype",
      error: "",
      orderData: [],
      total: 0,
      surcharge: 0,
      gst: 0,
      table: "",
    };
  },
  async created() {
    this.setStore(this.storeid);
    if (this.$route.query.table) {
      orderTypeHelper.setOrderTypeDineIn();
      this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DINEIN);
    }

    if (
      this.currentStoreDoc &&
      this.currentStoreDoc.ViewComponentConfigs &&
      this.currentStoreDoc.ViewComponentConfigs.MultipleMenus === false
    ) {
      this.multipleMenus = false;
    }
    if (
      this.currentStoreDoc &&
      this.currentStoreDoc.ViewComponentConfigs &&
      this.currentStoreDoc.ViewComponentConfigs.ShareCart &&
      orderTypeHelper.isDineIn()
    ) {
      this.getTableOrder(this.storeid);
      this.table = this.$route.query.table;

      const result = await getOrderSummary(
        this.storeid,
        this.$route.query.table
      );

      // activate the table
      if (result.error === 'Order not found') {
        const deviceResult = await getDeviceUDID(this.storeid);
        if (deviceResult.error) logger.log('device UDID', deviceResult.error, `/?table=${this.table}`, 'error', null, 'held order');
        else {
          const posMessage = createOrderForPOS(deviceResult.deviceID, this.table);
          // write to message queue
          try {
            const response = await writeMessageQueue(
              this.storeid,
              deviceResult.deviceID,
              'CloudOrders',
              JSON.stringify(posMessage),
              0,
              7,
              uuid(),
              Date.now()
            );
            if (response.error) {
              logger.log('device UDID', response.error, `/?table=${this.table}`, 'error', null, 'held order');
            }
          } catch(error) {
            logger.log('device UDID', error, `/?table=${this.table}`, 'error', null, 'held order');
          }
        }
      }

      if (!result.error) {
        const orderID = result.data.UniqueCode;
        const order = await getOrder(this.storeid, orderID);
        if (order.error) this.error = order.error;
        else {
          const orderRef = listenOrder(this.storeid, orderID);
          this.setOrder(order);
          orderRef.on("child_changed", async (data) => {
            if (data.key === "Items") {
              const newOrder = await getOrder(this.storeid, orderID);
              this.setOrder(newOrder);
            }
          });
        }
      } else {
        this.error = result.error;
      }
    }
  },
  mounted() {
    window.addEventListener('focus', this.handleFocus);
    if (isiOS()) {
      window.addEventListener('pageshow', this.handleVisibilityChange);
    } else {
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }
    if (!sessionStorage.getItem("paymenttype")) {
      sessionStorage.setItem(
        "paymenttype",
        new URLSearchParams(window.location.search).get("paymenttype")
      );
    }
    this.updateShoppingCartItems();
  },
  beforeDestroy() {
    if (isiOS()) {
      window.removeEventListener('pageshow', this.handleVisibilityChange);
    } else {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
    window.removeEventListener('focus', this.handleFocus);
  },
  computed: {
    ...mapGetters([
      "storeMenu",
      "getloadedMenu",
      "viewConfig",
      "selectedCompany",
      "currentStoreDoc",
      "showNewUi",
      "getOrderTypeModalDisplay",
      "showSharedCart",
      "getAddToCartOpen",
      "getModalProp",
      "UnavailableCategories",
      "showGuestCount",
      "storeClosed",
      "getLivenBranchID",
      "shouldDisplayBill",
      "getSharedCartProps",
    ]),
    availableCategories() {
      return this.storeMenu.Categories.filter(
        (ct) => !this.UnavailableCategories.includes(ct.ID.toString())
      );
    },
    getHeight() {
      if (this.showNewUi) {
        return 154;
      }
      var result = !this.isShowPopular && this.isShowReorder ? 334 : 158;

      // if (this.showSearchBox) {
      //   result -= 50;
      // }
      return result;
    },
    showOrderTypePopup() {
      return (
        this.multipleMenus && !this.$route.query.table && !this.storeClosed
      );
    },
    storeReady() {
      return this.storeMenu && this.getloadedMenu && this.currentStoreDoc;
    },
    getCartOpen() {
      return this.showNewUi && this.getAddToCartOpen;
    },
    showEnterNamePopUp() {
      return this.$route.query.table;
    },
  },
  watch: {
    getOrderTypeModalDisplay() {
      this.$nextTick(() => {
        this.orderTypeKey = Math.random();
        this.$forceUpdate();
      });
    },
  },
  methods: {
    ...mapMutations(["setStore", "setSelectedMenuType"]),
    ...mapActions([
      "getStoreMenu",
      "updateShoppingCartItems",
      "initPayTable",
      "getTableOrder",
      "displayLivenPay",
      "clearCart",
    ]),
    filterTextchange(txt) {
      this.filterText = txt;
    },
    setPopularVisibility(isVisible) {
      this.isShowPopular = isVisible;
    },
    toggleAddToCartOpen(isOpen) {
      this.addToCartOpen = isOpen;
    },
    openSharedCart() {
      this.$refs.orderBillBottomSheet.open();
    },
    setOrder(order) {
      if (!order || !order.data) return;
      this.orderData = order.data.Items;
      this.total = order.data.TotalCost;
      this.surcharge = order.data.SurchargeAmount;
      this.gst = order.data.TotalGst;
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible' || isiOS()) {
        // The mobile device is unlocked
        if (this.showSharedCart) {
          this.executeCodeWhenUnlocked();
        }
      }
    },
    handleFocus() {
      // Handle the browser window regaining focus
      if (this.showSharedCart) {
        this.executeCodeWhenUnlocked();
      }
    },
    async executeCodeWhenUnlocked() {
      try {
        await sleep(3000);
        const data = await readProductData(this.table, this.storeid);
        if (!data) {
          this.clearCart();
        }
        else {
          const names = Object.keys(data);
          if (!names.includes(this.getSharedCartProps.user)) {
            this.clearCart();
          }
        }
      } catch (error) {
        logger.log('shared cart', error, `/store/${this.storeid}`, 'error', '', '');
      }
    },
  },
};
</script>
